import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', // 'xs', 'sm', 'md', 'lg', 'xl'
  color = 'blue', // 'blue', 'gray', 'white', 'green', 'red'
  center = true,
  text,
  className = ''
}) => {
  const getSizeClasses = (size) => {
    switch (size) {
      case 'xs':
        return 'h-3 w-3';
      case 'sm':
        return 'h-4 w-4';
      case 'md':
        return 'h-8 w-8';
      case 'lg':
        return 'h-12 w-12';
      case 'xl':
        return 'h-16 w-16';
      default:
        return 'h-8 w-8';
    }
  };

  const getColorClasses = (color) => {
    switch (color) {
      case 'blue':
        return 'border-blue-600';
      case 'gray':
        return 'border-gray-600';
      case 'white':
        return 'border-white';
      case 'green':
        return 'border-green-600';
      case 'red':
        return 'border-red-600';
      default:
        return 'border-blue-600';
    }
  };

  const sizeClasses = getSizeClasses(size);
  const colorClasses = getColorClasses(color);

  const spinner = (
    <div className={`animate-spin rounded-full border-b-2 ${sizeClasses} ${colorClasses} ${className}`}></div>
  );

  if (!center && !text) {
    return spinner;
  }

  return (
    <div className={`flex ${text ? 'flex-col' : ''} items-center justify-center ${center ? 'h-64' : ''} space-y-2`}>
      {spinner}
      {text && (
        <p className="text-sm text-gray-600 mt-2">{text}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;